.section {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 2.4rem;
  border-radius: 0.4rem;
  border: 1px solid var(--color-grayscale-trout);
}

.section-items {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  &:not(:last-child) {
    padding-bottom: 1.6rem;
    border-bottom: 1px solid var(--color-grayscale-trout);
  }
}
